import styled, { css } from 'styled-components';

export const MessageWrapper = styled.div`
  ${({ theme }) => css`
    max-width: ${p => p.hasImage ? '200px' : '532px'};
    min-width: 134px;
    padding: 8px 12px;
    border: 1px solid ${p => p.right ? `${theme.colour.primary}80` : '#E3E3E3'};
    background-color: ${p => p.right ? `${theme.colour.primary}0D` : '#FFFFFF'};
    box-sizing: border-box;
    cursor: pointer;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: ${p => p.right ? '8px 0px 8px 8px' : '0px 8px 8px 8px'};
  `}
`;
